import React from 'react'
import { BLOCKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import ItemShop from '../../atoms/itemShop/item-shop'
import { pushGtagEvent } from '../../../shared/utils/metricManagementUtil'
import { dataLayerUserInfo } from '../../../shared/utils/userInfo'
import { convertText } from '../../../shared/utils/convertFirstCharacterToUppercase'
import './shopping-car.scss'

const ShoppingCar = ({
	samples,
	jsonProductSelec,
	removeSample,
	actionCar,
	labelButton,
}) => {
	const referencesMap = new Map()
	jsonProductSelec.references?.forEach(ref => {
		referencesMap.set(ref.contentful_id, ref)
	})
	const options = {
		renderNode: {
			[BLOCKS.EMBEDDED_ASSET]: node => {
				const assetId = node.data.target.sys.id
				const asset = referencesMap.get(assetId)
				if (!asset) {
					console.warn('Asset or file is undefined for node:', node)
					return null
				}

				return (
					<img
						className='f-shopping-content-product-image'
						src={asset.file?.url}
						alt={asset.title || 'Contentful Asset'}
					/>
				)
			},
			[BLOCKS.PARAGRAPH]: (node, next) =>
				next.toString().length ? (
					<p className='f-shopping-content-product-description'>{next}</p>
				) : undefined,
		},
	}

	const userInfo = dataLayerUserInfo()
	return (
		<div className='f-shopping'>
			<div className='f-shopping-border'></div>
			<div className='f-shopping-content'>
				<div className='f-shopping-content-product'>
					{documentToReactComponents(JSON.parse(jsonProductSelec.raw), options)}
					<span className='f-shopping-content-product-items'>
						{samples.length}
					</span>
				</div>
				<div className='f-shopping-content-elements'>
					{samples.map((sample, key) => (
						<ItemShop
							key={key}
							sample={sample}
							actionClose={() => {
								removeSample(sample.id, sample.size)
								const gtag = {
									event: 'remove_from_cart',
									params: {
										items: [
											{
												item_id: sample.id,
												item_name: sample.name,
												discount: 0,
												affiliation: 'Tena Online',
												item_brand: 'Tena',
												item_category: sample.categoria,
												item_variant: sample.variant,
												price: 0,
												currency: process.env.LOCALE,
												quantity: 1,
											},
										],
										value: 0,
										option: 'Tena Muestras Gratis',
										flow_type: 'Muestra Gratis',
										drip_degree: sample.drip_degree,
										user_data: userInfo.user_data ? userInfo.user_data : '',
										log_status: userInfo.log_status,
									},
								}
								pushGtagEvent(gtag)
							}}
						/>
					))}
				</div>
				<button
					onClick={actionCar}
					onClickCapture={() => {
						const gtag = {
							event: 'begin_checkout',
							params: {
								flow_type: 'muestra gratis',
								items: [],
								value: 0,
								user_data: userInfo.user_data ? userInfo.user_data : '',
								log_status: userInfo.log_status,
							},
						}

						samples.forEach(sample => {
							gtag.params.items.push({
								item_id: sample.id,
								item_name: sample.name,
								discount: 0,
								affiliation: 'Tena Online',
								item_brand: 'Tena',
								item_category: sample.categoria,
								item_variant: sample.variant,
								price: 0,
								currency: process.env.LOCALE,
								quantity: 1,
								drip_degree: sample.drip_degree,
							})
						})
						pushGtagEvent(gtag)
					}}
					className='f-shopping-content-button'
				>
					{convertText(labelButton)}
				</button>
			</div>
		</div>
	)
}

export default ShoppingCar
